import { FC } from 'react';
import classNames from 'classnames';
import { t } from '@whitesharx/starfall-frontend-ttranslate';

import { ProcessedAnalyzedMove, Eval } from '../../types';
import { formatEval } from '../../utils';

import {
  containerStyles,
  scoreStyles,
  scaleStyles,
  tooltipStyles,
  scaleContainerStyles,
  scorePositionStyles,
} from './styles.css';

type Props = {
  move: ProcessedAnalyzedMove | null;
  className?: string;
};

const RANGE = 20;

const convertScoreToOffset = (score = 0) => {
  if (score > 10) {
    return RANGE;
  }

  if (score < -10) {
    return 0;
  }

  return score + 10;
};

const shortEval = (evaluation?: Eval) => {
  if (!evaluation) {
    return undefined;
  }

  if (evaluation.cp !== undefined) {
    const score = Math.abs(evaluation.cp / 100);
    const digits = score >= 10 ? 0 : 1;

    return score.toFixed(digits);
  }

  return `M${Math.abs(evaluation.mate)}`;
};

const EvaluationBar: FC<Props> = ({ move, className }) => {
  const formatted = move?.eval !== undefined ? formatEval(move.eval) : undefined;
  const scoreToOffset = convertScoreToOffset(move?.score);
  const offset = 100 - (scoreToOffset * 100) / RANGE;

  const score = move?.eval?.cp ?? move?.eval?.mate;

  return (
    <div className={classNames(containerStyles, className)}>
      <div className={scaleContainerStyles}>
        <div className={scaleStyles} style={{ transform: `translateY(${offset}%)` }} />
      </div>
      {move?.eval && (
        <div
          className={classNames(scoreStyles, scorePositionStyles[score !== undefined && score > 0 ? 'bottom' : 'top'])}
        >
          {shortEval(move.eval)}
        </div>
      )}
      {move && <div className={tooltipStyles}>{formatted ?? t('analysis.run')}</div>}
    </div>
  );
};

export default EvaluationBar;
